import PropTypes from "prop-types";

import { dispatch, getState } from "../../../../state/store";
import { setFwuEvents } from "../../../../state/ducks";
import { selectRum } from "../../../../state/selectors";

import { chartNames, strCode } from "../../../../consts";
import { t } from "../../../../services";
import { firmwareDashboardUtil, rumEventsUtil } from "../../../../utils";

import { DashboardBarChart, GradientLoader } from "../../../../components";
import { DashboardTemplate } from "../../../../templates";

import { DeviceTabsSelector } from "../components";
import { MetricMainValue } from "../styled";

const FWUStatisticsChart = ({
  fwu,
  getChartFilter = () => {},
  getIsLoading = () => {},
  getIsError = () => {},
  downloadCSV = () => {}
}) => {
  const onDownloadStatisticsCSV = () => {
    const res = firmwareDashboardUtil.getFWStatisticsReport(fwu?.data);
    downloadCSV(res, t(strCode.FWU_STATISTICS_TITLE));
  };

  return (
    <DashboardTemplate
      id={chartNames.FWU_STATISTICS}
      title={strCode.FWU_STATISTICS_TITLE}
      isLoading={getIsLoading(chartNames.FWU_STATISTICS)}
      onDownloadCSV={fwu?.data ? onDownloadStatisticsCSV : null}
      Component={DeviceTabsSelector}
      onUpdateChartData={(devices) => {
        const rum = selectRum(getState());
        const data = rum?.fwu?.data;

        if (data) {
          const { result: fwuStatistics, totalFWUCount } =
            firmwareDashboardUtil.getFwUpdateStatistics(data, devices);

          dispatch(
            setFwuEvents({
              statistics: fwuStatistics,
              total: totalFWUCount
            })
          );
        }
      }}>
      <MetricMainValue>
        {getIsLoading(chartNames.FWU_STATISTICS) ? (
          <GradientLoader width={120} height={32} />
        ) : (
          fwu?.total
        )}
      </MetricMainValue>

      <DashboardBarChart
        data={fwu?.statistics}
        isLoading={getIsLoading(chartNames.FWU_STATISTICS)}
        isError={getIsError(chartNames.FWU_STATISTICS)}
        yAxisLabel={strCode.COUNT_LABEL}
        metricsConfig={rumEventsUtil.getMetricsConfig({
          chartName: chartNames.FWU_STATISTICS,
          deviceType: getChartFilter(chartNames.FWU_STATISTICS)
        })}
      />
    </DashboardTemplate>
  );
};

FWUStatisticsChart.propTypes = {
  fwu: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    total: PropTypes.number.isRequired,
    statistics: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string.isRequired,
        metrics: PropTypes.objectOf(PropTypes.number).isRequired
      })
    ).isRequired
  }).isRequired,
  getChartFilter: PropTypes.func.isRequired,
  getIsLoading: PropTypes.func.isRequired,
  getIsError: PropTypes.func.isRequired,
  downloadCSV: PropTypes.func.isRequired
};

export default FWUStatisticsChart;
